<!-- originFileNameList の配列の originalFileName を箇条書きで表示する -->
<ul *ngIf="originFileNameList.length > 1">
  <li *ngFor="let element of originFileNameList" class="file-list-item">
    {{ element.originalFileName }}
  </li>
</ul>
